import React from "react";
import theme from "./config/theme";
import AuthModal from "./AuthCenter/AuthModal/AuthModalContainer";
import "./styles/styles.scss";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider as LegacyThemeProvider } from "@mui/styles";
import { NotificationCenterProvider } from "./NotificationCenter";
import { AuthCenterProvider } from "./AuthCenter";
import { SmartFilterProvider } from "./SmartFilterProvider";
import Routes from "./routes/Routes";

const App = () => (
  <ThemeProvider theme={theme}>
    <StyledEngineProvider injectFirst>
      <LegacyThemeProvider theme={theme}>
        <NotificationCenterProvider>
          <BrowserRouter>
            <AuthCenterProvider>
              <SmartFilterProvider>
                <Routes />
              </SmartFilterProvider>
              <AuthModal />
            </AuthCenterProvider>
          </BrowserRouter>
        </NotificationCenterProvider>
      </LegacyThemeProvider>
    </StyledEngineProvider>
  </ThemeProvider>
);

export default App;
